<section class="section breadcrumb-area bg-overlay d-flex align-items-center">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <!-- Breamcrumb Content -->
                <div class="breadcrumb-content d-flex flex-column align-items-center text-center">
                    <h3 class="text-white">Blog - Right Sidebar</h3>
                    <ol class="breadcrumb justify-content-center">
                        <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                        <li class="breadcrumb-item"><a href="#">Blog Pages</a></li>
                        <li class="breadcrumb-item active">Blog - Right Sidebar</li>
                    </ol>
                </div>
            </div>
        </div>
    </div>
</section>